export enum PricingMethods {
  PER_ORDER = 1,
  PER_LINE = 2,
  PER_CUSTOMER = 3,
}
